<template>
  <div class="page-section">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title">Video</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <vue-load-image>
          <div slot="image" alt="slight production video slika" class="box-transform" :data-src="require('./../images/video/bg-slight-production-video.jpg')" :style="{ backgroundImage: 'url(' + require('./../images/video/bg-slight-production-video.jpg') + ')' }"></div>
          <div slot="preloader" class="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>          
          <div slot="error">učitavam sliku...</div>
        </vue-load-image>         
      </div>     
    <section class="section video_gallery section_responsive" id="video">     
        <div class="box-spacer">
          <!-- <p class="heading-1">Video</p><br/> -->
          <div class="categories">
                <ul class="type">
                  <li v-for="(category) in categories" :key="category.id" v-bind:class="[category.isVisible ? '' : 'hidden']">
                      <a class="button button-primary-outline" v-bind:class="[category.isActive ? 'active' : '']" @click="filterByCategory(category.id)">{{category.name}}</a>
                  </li>                
                </ul>
          </div>
        </div>
          <div class="shell-fluid-mobile shell-condensed">
            <div class="range range-condensed" data-lightgallery="group">
              <div  v-for="(video, index) in videoList" :key="index" class="cell-sm-6 cell-md-4 cell-lg-3 image-item fade-in">
                  <a class="thumb-ruby thumb-mixed_height-4" @click="showModalWindow(index)" data-lightgallery="group-item">
                    <img class="thumb-ruby__image" :src="getSrcLink(index)" :alt="video.Title" width="400" height="363">
                    <div class="thumb-ruby__caption"> 
                      <p class="thumb-ruby__title heading-3"></p>
                      <p class="thumb-ruby__text"></p>
                    </div>
                  </a>
              </div>
            </div>
          </div>

          <div v-bind:class="[modalIsActive ? 'in' : 'hidden']" class="lg-backdrop" style="transition-duration: 150ms;"></div>
          <div v-bind:class="[modalIsActive ? 'show-image' : 'hidden']" class="image-gallery-modal lg-outer lightGallery-in-carousel lg-css3 lg-use-transition-for-zoom lg-visible show-image">     
            <div class="lg" style="width:100%; height:100%">
              <div class="lg-inner" style="transition-timing-function: ease; transition-duration: 600ms;">
                <div class="lg-item lg-next-slide lg-prev-slide lg-loaded lg-current lg-complete lg-zoomable">
                  <div class="lg-img-wrap">
                    <iframe width="1280" height="720" :src="getVideoUrl(this.currentID)" frameborder="0" allowfullscreen></iframe>
                  </div>
                </div>
              </div>
              <div class="close-icon-container">
                <img src="./../icons/close_icon.png" alt="close icon" class="modal-close-icon" @click="closeModalWindow()">
              </div>        
            </div>
          </div>        
    </section>
  </div>  
</template>

<script>
import axios from 'axios';
export default {
  metaInfo(){
    return{
      title: 'S light production - video galerija, vjenčanja, koncerti i događaji',
      meta:[
        {
          name: 'description',
          content: 'S light production - video galerija - snimanje video uradaka za Vaše tvrtke, ali i snimanje glazbenih spotova, koncerta, svečanosti, modne revije, plesna događanja, promocije, televizijska snimanja, sajmovi, izložbe, vjenčanja, privatne zabave'
        }
      ]
    }
  },    
   data(){
      return{
        componentLoaded: false,
        currentID: 0,          
        videoList: '',
        originalVideoList:'',
        modalIsActive: false,
        categories: [
          {
            id: 0,
            name: 'Sve',
            isActive: false,
            isVisible: true            
          },           
          {
            id: 1,
            name: 'Vjenčanja',
            isActive: true,
            isVisible: true
          },
          {
            id: 2,
            name: 'Koncerti',
            isActive: false,
            isVisible: true            
          }                       
        ]

      }  
   },
   methods:{
       fetchData(){
            axios({
              method: 'get',
              url: this.apiPath + 'gallery/readVideoGallery.php'
            })
            .then(function(response) {
                this.videoList = response.data;
                this.originalvideoList = this.videoList;

                this.componentLoaded = true;
                this.filterByCategory(0);
                this.checkCategoryMenuVisibility();
            }.bind(this))
            .catch((error) => {
              console.log(error);
            });             
       },
       showModalWindow(id){
         this.modalIsActive = true;
         this.currentID = id;
       },       
       closeModalWindow(){
         this.modalIsActive = false;
         this.currentID = -1;
       },
       filterByCategory(categoryId){
        if(categoryId == 0){
          this.videoList = this.originalvideoList;
        }else{
          this.videoList = this.originalvideoList.filter(c => c.CategoryId.indexOf(categoryId) > -1);
        }       

        //Remove active links
        this.categories.forEach((link) => {
          link.isActive = false;
        });
        
        //Set active category
        var categoryIndexPosition = this.categories.findIndex(x=> x.id === categoryId);    
        this.categories[categoryIndexPosition].isActive = true;   
       }, 
       getVideoUrl(id){
          if(! this.componentLoaded || this.videoList.length <= 0 || this.currentID < 0)
            return null;
          
          var videoUrl = this.videoList[this.currentID].UrlLink;
          var url = videoUrl.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
          var videoID = (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
          return 'https://www.youtube.com/embed/' + videoID;
        },
        checkCategoryMenuVisibility(){
          this.categories.forEach((category) => {
            if(this.originalvideoList.filter(c => c.CategoryId.indexOf(category.id) > -1).length <= 0 && category.id != 0){
              var objIndex = this.categories.findIndex((obj => obj.id == category.id));
              this.categories[objIndex].isVisible = false;
            }
          });          
        }   
   },
   computed: {
      getSrcLink: function() {
        return function(id) {
          if(! this.componentLoaded)
            return null;
          return this.dataPath + 'video_gallery/' + this.videoList[id].Thumb;
      }
    }
   },   
   created(){
       this.fetchData();
   }   
}
</script>

<style lang="scss">
.about-us{   
    &.bg-gray-lighter {
        background-color: #f2f3f8;
    }
}
.page{ 
  .categories{
    ul{
      li {
        display: inline-block;
        margin-right: 20px;
        cursor: pointer;
        margin-bottom: 1rem;
        a {
          min-width: 0px;

          &.active{
            color: #ffffff;
            background-color: #a7cf38;
            border-color: #a7cf38;
          }
        }
      }
    }
  }
}
.video_gallery{    
    .image-gallery-modal{
      .lg{
        .lg-inner{
          .lg-item{
            .lg-img-wrap{
              iframe{
                width: 85%;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                margin: auto;
              }
            }
          }
        }
      }
    }   
}

    .shell-fluid{
      .range{
        .image-item{
          opacity: 0;
          
          &.fade-in{
            visibility: visible;
            opacity: 1;
            transition: visibility 0s 2s, opacity .5s linear;
          }

          &.fade-out{
            visibility: hidden;
            opacity: 0;
            transition: visibility 0s 2s, opacity .5s linear;
          }
        }
      }
    }
.hidden{
  display:none;
}

iframe{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;  
}

@media only screen and (max-width: 768px) {
  .page{
    padding: 0;
    .image-gallery-modal{
      .lg{
        .lg-inner{
          .lg-item{
            .lg-img-wrap{
              iframe{
                width: 100%;
                height: 50%;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                margin: auto;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue